import bairro from './bairro'
import cidadao from './cidadao'
import convenioMedico from './convenio-medico'
import convenioOdontologico from './convenio-odontologico'
import logradouro from './logradouro'
import logradouroTipo from './logradouro-tipo'
import loteamento from './loteamento'
import ocupacao from './ocupacao'
import planoFunerario from './plano-funerario'
import usuario from './usuario'
import usuarioOrigem from './usuario-origem'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    return {
        bairro: bairro(baseUrl),
        cidadao: cidadao(baseUrl),
        convenioMedico: convenioMedico(baseUrl),
        convenioOdontologico: convenioOdontologico(baseUrl),
        logradouro: logradouro(baseUrl),
        logradouroTipo: logradouroTipo(baseUrl),
        loteamento: loteamento(baseUrl),
        ocupacao: ocupacao(baseUrl),
        planoFunerario: planoFunerario(baseUrl),
        usuario: usuario(baseUrl),
        usuarioOrigem: usuarioOrigem(baseUrl),
    }
}